import { FC } from 'react';
import { enhanceComponent } from '@legacyApp/client/wrappers/enhanceComponent';
import { PackageType } from '@legacyApp/client/store/registry/registry.constants';
import { GameType } from '@modules/games/Game/constants/availableGames';

const GamesStoreController: FC = () => null;

export const gamesStoreProps = {
	asyncReducers: [
		{
			id: 'game',
			callback: () =>
				import('../../../modules/games/Game/store/game/game.reducer'),
		},
		{
			id: 'gameSession',
			callback: () =>
				import(
					'../../../modules/games/Game/store/gameSession/gameSession.reducer'
				),
		},
		{
			id: 'gameAutobet',
			callback: () =>
				import(
					'../../../modules/games/Game/store/gameAutobet/gameAutobet.reducer'
				),
		},
		{
			id: 'gameValidation',
			callback: () =>
				import(
					'../../../modules/games/Game/store/gameValidation/gameValidation.reducer'
				),
		},
		{
			id: GameType.DICE,
			callback: () =>
				import('../../../modules/games/Game/store/dice/dice.reducer'),
		},
		{
			id: GameType.HILO,
			callback: () =>
				import('../../../modules/games/Game/store/hilo/hilo.reducer'),
		},
		{
			id: GameType.LIMBO,
			callback: () =>
				import('../../../modules/games/Game/store/limbo/limbo.reducer'),
		},
		{
			id: GameType.PLINKO,
			callback: () =>
				import('../../../modules/games/Game/store/plinko/plinko.reducer'),
		},
		{
			id: GameType.KENO,
			callback: () =>
				import('../../../modules/games/Game/store/keno/keno.reducer'),
		},
	],
	asyncEpics: [
		{
			id: 'game',
			callback: () =>
				import('../../../modules/games/Game/store/game/game.epic'),
		},
		{
			id: 'gameSession',
			callback: () =>
				import(
					'../../../modules/games/Game/store/gameSession/gameSession.epic'
				),
		},
		{
			id: 'gameAutobet',
			callback: () =>
				import(
					'../../../modules/games/Game/store/gameAutobet/gameAutobet.epic'
				),
		},
		{
			id: 'gameValidation',
			callback: () =>
				import(
					'../../../modules/games/Game/store/gameValidation/gameValidation.epic'
				),
		},
		{
			id: GameType.DICE,
			callback: () =>
				import('../../../modules/games/Game/store/dice/dice.epic'),
		},
		{
			id: GameType.HILO,
			callback: () =>
				import('../../../modules/games/Game/store/hilo/hilo.epic'),
		},
		{
			id: GameType.LIMBO,
			callback: () =>
				import('../../../modules/games/Game/store/limbo/limbo.epic'),
		},
		{
			id: GameType.KENO,
			callback: () =>
				import('../../../modules/games/Game/store/keno/keno.epic'),
		},
		{
			id: 'flash',
			callback: () =>
				import('../../../modules/games/Game/store/flash/flash.epic'),
		},
	],
	asyncDoNotReject: true,
	asyncPackage: PackageType.GAME,
};

export default enhanceComponent({
	GamesStoreController,
	props: gamesStoreProps,
});
